// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aEBeO65BJT4z2oc_z5vo{display:flex;flex-direction:column;margin:20px 0}.MSOkM5WBbHF9sjArfjZl{font-weight:500;padding:0 16px}`, "",{"version":3,"sources":["webpack://./components/DefectValidator/data/defectNotifyPopup/defectNotifyPopup.module.scss"],"names":[],"mappings":"AACA,sBACE,YAAA,CACA,qBAAA,CACA,aAAA,CACA,sBACE,eAAA,CACA,cAAA","sourcesContent":["\r\n.content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 20px 0;\r\n  &__title {\r\n    font-weight: 500;\r\n    padding: 0 16px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `aEBeO65BJT4z2oc_z5vo`,
	"content__title": `MSOkM5WBbHF9sjArfjZl`
};
export default ___CSS_LOADER_EXPORT___;
